var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9073_65592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 5.33398H5.33992M1.33325 3.46732L1.33325 6.45033C1.33325 6.77645 1.33325 6.93951 1.37009 7.09296C1.40275 7.22901 1.45663 7.35907 1.52973 7.47836C1.61219 7.61292 1.72749 7.72822 1.95809 7.95882L7.07051 13.0712C7.86254 13.8633 8.25856 14.2593 8.71522 14.4077C9.1169 14.5382 9.5496 14.5382 9.95129 14.4077C10.4079 14.2593 10.804 13.8633 11.596 13.0712L13.0705 11.5967C13.8625 10.8047 14.2586 10.4087 14.4069 9.95202C14.5375 9.55033 14.5375 9.11764 14.4069 8.71595C14.2586 8.25929 13.8625 7.86328 13.0705 7.07124L7.95809 1.95882C7.72749 1.72822 7.61219 1.61292 7.47763 1.53046C7.35833 1.45736 7.22828 1.40349 7.09223 1.37082C6.93878 1.33398 6.77572 1.33398 6.4496 1.33398L3.46659 1.33398C2.71985 1.33398 2.34648 1.33398 2.06127 1.47931C1.81038 1.60714 1.60641 1.81111 1.47858 2.062C1.33325 2.34721 1.33325 2.72058 1.33325 3.46732ZM5.66659 5.33398C5.66659 5.51808 5.51735 5.66732 5.33325 5.66732C5.14916 5.66732 4.99992 5.51808 4.99992 5.33398C4.99992 5.14989 5.14916 5.00065 5.33325 5.00065C5.51735 5.00065 5.66659 5.14989 5.66659 5.33398Z",
    stroke: "#424242",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9073_65592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag01);
export default __webpack_public_path__ + "static/media/tag-01.439b42d03bd8cd7ec612b36d87be0d83.svg";
export { ForwardRef as ReactComponent };